import React from 'react';
import { AssignName } from 'src/features/device-activation/pages/assign-name/AssignName';
import { PageName } from 'src/features/device-activation/pages/page-names';
import { ScanDevice } from 'src/features/device-activation/pages/scan-device/ScanDevice';
import { OrderPostSubmitResult } from 'src/features/dpo/pages/order-post-submit-result/order-post-submit-result';
import { YourDetails } from 'src/features/dpo/pages/your-details/your-details';

export const pageNameMap: Map<string, React.ReactFragment> = new Map([
  [PageName.YOUR_DETAILS, YourDetails],
  [PageName.SCAN_DEVICE, ScanDevice],
  [PageName.ASSIGN_NAME, AssignName],
  [PageName.SETUP_YOUR_ACCOUNT, OrderPostSubmitResult],
]);
